import {useEffect, useState} from "react";
import {useVendorsStore} from "../../../store/vendors.store";
import {useAuthStore} from "../../../store/auth.store";
import {useVendorDocuments} from "../../../hook/partner/vendorDocuments.partner.hook";
import {PartnerApi} from "../../../api/partner.api";
import { useTranslation } from "../../../hooks/useTranslation";

function VendorDetailDocuments(props) {
    const { t } = useTranslation();
    const vendor = props.vendor;

    const [page, setPage] = useState(0);

    const vendorDocumentsMutation = useVendorDocuments();

    const token = useAuthStore((state) => state.token);
    const documents = useVendorsStore((state) => state.documents);

    useEffect(() => {
        if (token) {
            vendorDocumentsMutation.mutate(
                {token, id: vendor.vendor_id}
            )
        }
    }, [token, vendor]);


    if (vendorDocumentsMutation.isLoading) {
        return <p>{t("common.loading")}</p>;
    }

    if (!documents) {
        return <></>;
    }

    if (documents?.length === 0) {
        return <></>;
    }
    return (
        <>
            {/*
            <h1 className={"mt-16 mb-4"}>Dokumenty</h1>
            */}
            <div className="row">
                <div className="col-12 col-md-3">
                    <div className="menu menu-rounded menu-column menu-gray-600 menu-state-bg fw-semibold">
                        {documents?.length > 0 && (
                            documents?.map((documentsItem, documents_key) => (
                                <div className="menu-item" key={documents_key}>
                                    <span onClick={() => setPage(documents_key)}
                                          className={"cursor-pointer menu-link " + (documents_key == page ? "active" : "")}
                                    >
                                        {documentsItem.group_name}
                                    </span>
                                </div>
                            ))
                        )}
                    </div>
                </div>
                <div className="col-12 col-md-9">
                    {page in documents && documents[page]?.files?.length > 0 ? (
                        <table className="table table-bordered"><tbody>
                        {documents[page]?.files?.map((filesItem, files_key) => (
                                <tr key={files_key}>
                                    <td className="w-100">{filesItem.description}</td>
                                    <td>
                                        {(filesItem.link && filesItem.link != "") ? (
                                                <a className="btn btn-primary btn-sm text-nowrap"
                                                   href={filesItem.link} target={"_blank"}>{t("vendors.goToLink")}</a>
                                        ): (
                                            <button
                                                onClick={() => PartnerApi.download("/vendor/" + vendor.vendor_id + "/documents/" + filesItem.file_id + "/" + filesItem.name, filesItem.name, token)}
                                                className="btn btn-primary btn-sm">{t("common.download")}</button>
                                        )}
                                    </td>
                                </tr>
                        ))}
                        </tbody>
                        </table>
                    ) : (
                        <p>{t("vendors.noDocument")}</p>
                    )}
                </div>
            </div>
        </>
    );
}

export default VendorDetailDocuments;
